// import { Course } from './model/course.model';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from './../store/reducers/index';
import { LoadAccounts } from './store/account/account.actions';

@Injectable()
export class AccountResolver implements Resolve<Observable<any>> {
    constructor(private store: Store<AppState>) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // return this.store
        //     .pipe(
        //         select(areAccountsLoaded),
        //         tap((accountsLoaded) => {

        //             if (!accountsLoaded) {
        //                 this.store.dispatch(LoadAccounts({ useCache: false, detailed: true }));
        //             }
        //         }),
        //         filter(accountsLoaded => accountsLoaded),
        //         first()
        //     );

        this.store.dispatch(LoadAccounts({ useCache: false, detailed: true }));
        return null;
    }
}
